module.exports = __webpack_public_path__ + "static/img/products6.0deacfb6.png";